function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.238281 24.886719 L 12.738281 24.886719 C 12.144531 24.886719 11.691406 24.429688 11.691406 23.835938 L 11.691406 11.933594 C 11.691406 11.339844 12.144531 10.886719 12.738281 10.886719 L 23.238281 10.886719 C 23.835938 10.886719 24.289062 11.339844 24.289062 11.933594 L 24.289062 23.835938 C 24.289062 24.394531 23.800781 24.886719 23.238281 24.886719 Z M 13.089844 23.484375 L 22.890625 23.484375 L 22.890625 12.285156 L 13.089844 12.285156 Z M 13.089844 23.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 25.691406 22.433594 C 25.304688 22.433594 24.988281 22.121094 24.988281 21.734375 L 24.988281 10.183594 L 14.839844 10.183594 C 14.453125 10.183594 14.140625 9.871094 14.140625 9.484375 C 14.140625 9.101562 14.453125 8.785156 14.839844 8.785156 L 25.199219 8.785156 C 25.761719 8.785156 26.390625 9.203125 26.390625 9.835938 L 26.390625 21.734375 C 26.390625 22.121094 26.074219 22.433594 25.691406 22.433594 Z M 25.164062 10.183594 Z M 25.164062 10.183594 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b69912c8f0801327084dc8e431de6e54.svg";
export { ForwardRef as ReactComponent };